export let LABELS = {
    TITLE: "Title",
    SCHEDULE_DATE: "Schedule Date",
    SCHEDULE_TIME: "Schedule time (CST)",
    AGE_GROUP: "Age Group",
    USER_GROUP: "User Group",
    STATUS: "Status",
    ACTION: "Action",
    NOTIFICATION_TYPE: "Notification Type",
    NOTIFICATION_MESSAGE: "Notification Message"
};

export let NAMES = {
    [LABELS.TITLE]: "title",
    [LABELS.NOTIFICATION_TYPE]: "notificationType",
    [LABELS.NOTIFICATION_MESSAGE]: "notificationMessage",
    [LABELS.AGE_GROUP]: "ageGroup",
    [LABELS.USER_GROUP]: "userGroup",
    [LABELS.SCHEDULE_DATE]: "scheduleDate",
    [LABELS.SCHEDULE_TIME]: "scheduleTime"
};

export let PLACEHOLDERS = {
    [LABELS.TITLE]: "Add Title",
    [LABELS.NOTIFICATION_TYPE]: "",
    [LABELS.NOTIFICATION_MESSAGE]: "Enter Notification Message",
    [LABELS.AGE_GROUP]: "Select Age Group",
    [LABELS.USER_GROUP]: "",
    [LABELS.SCHEDULE_DATE]: "Select Schedule Date",
    [LABELS.SCHEDULE_TIME]: "Select Schedule Time"
};
